import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, HOME_FOR_ROLE } from '../context/AuthContext';
import { Spinner } from './ui';

/** Blocks a route until the session is known, then checks the role. */
export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <Spinner label="Checking your session…" />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (role && user.role !== role) return <Navigate to={HOME_FOR_ROLE[user.role] || '/'} replace />;

  return children;
}
